<template>
  <div class="my-load">
    <img src="@/assets/image/logo.gif" alt="" width="160px" srcset="" />
  </div>
</template>
<script>
export default {
  name: "MyLoading",
  data() {
    return {};
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
.my-load {
  position: fixed;
  top: 40%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .el-icon-loading {
    font-size: 50px;
    color: #4ab1e4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyLoading.vue